export enum CookieName {
  USER_ID = "userId",
  REFERRAL_CODE = "referralCode",
  REFERRAL_RESPONSE = "referralResponse",
  EVENT_CODE = "eventCode",
  NEW_USER_EVENT = "newUserEvent",
  FBCLID = "_fbc",
  DIRECT_BOOKING_MODAL = "directBookingModal",
  MAPPED_REFERRED_BY = "mappedReferredBy",
  ONBOARDING_MAPPED_MODAL = "onboardingMappedModal",
  SYNC_TOKEN_EXPIRED = "syncTokenExpired",
  SOURCE_PARAMS = "sourceParams",
}
